import { oncePromise, run } from '../helper/electron';
import {
  AgentSourceId,
  defaultAgentSourceIncludes,
} from '../types/AgentSource';
import { setAgentSourceIncludesState } from './agentSourceIncludesState';

const GET = 'agent/get-source-includes';
const SET = 'agent/set-source-includes';

export const fetchAgentSourceIncludes = async (): Promise<
  Record<AgentSourceId, boolean>
> => {
  const response = oncePromise<{ includes?: Record<AgentSourceId, boolean> }>(
    GET,
  );
  run(GET);
  const { includes } = await response;
  const next = { ...defaultAgentSourceIncludes(), ...includes };
  setAgentSourceIncludesState(next);
  return next;
};

export const syncAgentSourceIncludes = (
  includes: Record<AgentSourceId, boolean>,
): void => {
  setAgentSourceIncludesState(includes);
  run(SET, { includes });
};
